import React, { createContext, useContext, useState, useCallback } from "react";

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [modalSubTitle, setModalSubTitle] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [modalWidth, setModalWidth] = useState(null);
  const [modalHeight, setModalHeight] = useState(null);

  const openModal = useCallback(
    (content, title = "", subTitle, width = null, height = null) => {
      setModalContent(content);
      setModalTitle(title);
      setModalSubTitle(subTitle);
      width === null ? setModalWidth(null) : setModalWidth(width);
      height === null ? setModalHeight(null) : setModalHeight(height);
      setIsOpen(true);
      

    },
    []
  );

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setModalContent(null);
    setModalTitle("");
    setModalSubTitle(null);
    setModalWidth(null);
    setModalHeight(null);
  }, []);

  const updateModalTitle = useCallback((title) => {
    setModalTitle(title);
  }, []);

  const updateModalSubTitle = useCallback((subTitle) => {
    setModalSubTitle(subTitle);
  }, []);

  return (
    <ModalContext.Provider
      value={{
        isOpen,
        modalContent,
        modalTitle,
        modalSubTitle,
        modalWidth,
        modalHeight,
        openModal,
        closeModal,
        updateModalTitle,
        updateModalSubTitle,
      }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);